import {Component, Inject, Input, OnInit} from '@angular/core';
import {BaseModalComponent, LibConfig, LibConfigService, Membership, MembershipService, Organization, PrinterService} from 'brewbill-lib';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'bb-claim-membership-qr',
    templateUrl: './claim-membership-qr.component.html',
    styleUrls: ['./claim-membership-qr.component.scss'],
})
export class ClaimMembershipQrComponent extends BaseModalComponent implements OnInit {
    @Input() organization: Organization;
    member: Membership;
    testMode = false;
    qrUrl: string;

    constructor(
        @Inject(LibConfigService) private config: LibConfig,
        private membershipService: MembershipService,
        private printerService: PrinterService,
        modalController: ModalController
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.member = this.membershipService.currentValue;
        this.testMode = this.config.testMode;

        this.createClaim();
        this.subscribe(this.membershipService.current.subscribe(m => {
            if (!m.claimCode) {
                this.close();
            }
        }));
    }

    createClaim() {
        if (!!this.member && !!this.member.claimCode) {
            this.testMode = this.config.testMode;
            this.qrUrl = `${this.config.mobileUrl}/#/${this.organization.id}/claim-membership/${this.member.id}?claimCode=${this.member.claimCode}`;
        }
    }

    async printClaim() {
        await this.printerService.printClaimMembership(this.member);
    }
}
